module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_51-2c8ed1a822c608c958a8e305b286fb14.png";